import {styled} from '@linaria/react';
import React from 'react';
import {DefaultList} from './List';

export const BulletPointList: React.FC<
  React.PropsWithChildren<{className?: string}>
> = ({children, className}) => {
  return (
    <StyledDefaultList className={className}>
      {React.Children.map(children, (child, i) => {
        if (!child) {
          return null;
        }
        return (
          <li key={i}>
            <span>{child}</span>
          </li>
        );
      })}
    </StyledDefaultList>
  );
};

const StyledDefaultList = styled(DefaultList)`
  list-style: inside;
  padding-left: 4px;

  & > li span {
    position: relative;
    left: -4px;
  }
`;
